export const PORTAL_CONTAINER_ID = "app-shell"

export const getPortalContainer = (): HTMLElement =>
  document.getElementById(PORTAL_CONTAINER_ID) ?? document.body
